import { render, staticRenderFns } from "./SectionFreelances.vue?vue&type=template&id=0a2c2352&scoped=true"
import script from "./SectionFreelances.vue?vue&type=script&lang=ts"
export * from "./SectionFreelances.vue?vue&type=script&lang=ts"
import style0 from "./SectionFreelances.vue?vue&type=style&index=0&id=0a2c2352&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2c2352",
  null
  
)

export default component.exports